import {
  datadogLogs, HandlerType, LogsInitConfiguration 
} from '@datadog/browser-logs'
import { datadogRum, DefaultPrivacyLevel } from '@datadog/browser-rum'

export const initDatadogRum = () => {
  if (!datadogRum.getInitConfiguration()) {
    const datadogConfig = {
      applicationId: process.env.GATSBY_DATADOG_APPLICATION_ID || '',
      clientToken: process.env.GATSBY_DATADOG_CLIENT_TOKEN || '',
      site: 'datadoghq.com',
      service: 'corgi-website',
      version: process.env.GATSBY_NETLIFY_BUILD_ID,
      env: process.env.GATSBY_ENV,
      sessionSampleRate: 100,
      sessionReplaySampleRate: process.env.GATSBY_ENV === 'production' ? 20 : 0,
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: DefaultPrivacyLevel.MASK_USER_INPUT,
    }

    datadogRum.init(datadogConfig)
    datadogRum.startSessionReplayRecording()
  }
}

export const initDatadogLogger = () => {
  if (!datadogLogs.getInitConfiguration()) {
    const dataDogLoggerConfig: LogsInitConfiguration = {
      clientToken: process.env.GATSBY_DATADOG_CLIENT_TOKEN || '',
      service: 'corgi-website',
      env: process.env.GATSBY_ENV,
      forwardErrorsToLogs: true,
      sessionSampleRate: 100,
    }

    datadogLogs.init(dataDogLoggerConfig)

    datadogLogs.setGlobalContextProperty('service', dataDogLoggerConfig.service)
    datadogLogs.setGlobalContextProperty('source', 'browser')
    datadogLogs.setGlobalContextProperty('env', dataDogLoggerConfig.env)
    datadogLogs.setGlobalContextProperty('team', 'ohs')

    if (dataDogLoggerConfig.env === 'local') {
      datadogLogs.logger.setHandler(HandlerType.console)
    }
  }
}
